module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_3016.d61f5d5d.png";